import { render, staticRenderFns } from "./quickorderList_child.vue?vue&type=template&id=82bda092&scoped=true"
import script from "./quickorderList_child.vue?vue&type=script&lang=js"
export * from "./quickorderList_child.vue?vue&type=script&lang=js"
import style0 from "./quickorderList_child.vue?vue&type=style&index=0&id=82bda092&prod&scoped=true&lang=css"
import style1 from "./quickorderList_child.vue?vue&type=style&index=1&id=82bda092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bda092",
  null
  
)

export default component.exports